import { Controller } from "@hotwired/stimulus"

// POWER is the universal, obvious kill switch on every widget bay. Widgets boot
// ONLY on this latch (never on scroll — CWV) and cut dead the moment it lifts.
//
// Controller element: the widget <figure> owning a [data-stage] element. Every
// [data-power] latch inside it (POWER in the strip, RUN on the poster) toggles one
// shared state:
//   - stage.dataset.on = "true" | "false"  (CSS swaps poster <-> canvas)
//   - aria-pressed + LED on every power latch
//   - a "dg:power" event {detail:{on}} that the widget module (e.g. playground-
//     planet) obeys
// [data-reset] latches dispatch "dg:reset" (re-arm defaults; power is untouched).
// Off by default, always. Audio (Monitor Bus tick) is deferred to a later PR, so
// the prototype's tick() calls are intentionally omitted.
export default class extends Controller {
  connect() {
    this.stage = this.element.querySelector("[data-stage]")
    this.powers = Array.from(this.element.querySelectorAll("[data-power]"))
    if (!this.stage || this.powers.length === 0) return
    this.on = false
    this._onClick = this._onClick.bind(this)
    this.element.addEventListener("click", this._onClick)
    this._render()
  }

  disconnect() {
    if (!this._onClick) return
    this.element.removeEventListener("click", this._onClick)
    // Cleanly cut power on teardown so any listening widget halts its loop.
    if (this.on) {
      this.on = false
      this._render()
      this.dispatch("power", { prefix: "dg", detail: { on: false } })
    }
  }

  _onClick(event) {
    const power = event.target.closest("[data-power]")
    if (power && this.element.contains(power)) {
      this.on = !this.on
      this._render()
      this.dispatch("power", { prefix: "dg", detail: { on: this.on } })
      return
    }
    const reset = event.target.closest("[data-reset]")
    if (reset && this.element.contains(reset)) {
      this.dispatch("reset", { prefix: "dg" })
    }
  }

  _render() {
    this.stage.dataset.on = String(this.on)
    this.powers.forEach((button) => {
      button.setAttribute("aria-pressed", String(this.on))
      button.querySelector(".led")?.classList.toggle("on", this.on)
    })
  }
}
